import { PropsWithChildren } from 'react';

import { FeatureFlagsContext, featureFlagsMap } from '@shared/providers/FeatureFlagsProvider/providerSetup.ts';

export function FeatureFlagsProvider({ children }: PropsWithChildren) {
  return <FeatureFlagsContext.Provider value={featureFlagsMap}>{children}</FeatureFlagsContext.Provider>;
}
